
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/advisory",
      function () {
        return require("private-next-pages/services/advisory.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/advisory"])
      });
    }
  